/**
 *
 * find the standard deviation from a list of numbers
 * Based off https://stackoverflow.com/questions/7343890/standard-deviation-javascript
 *
 */
import {isArray, isEmpty} from "lodash"

export default (numberList) => {
  if (!isArray(numberList)) return NaN
  if (isEmpty(numberList)) return NaN

  const n = numberList.length
  const mean = numberList.reduce((a, b) => a + b) / n
  /* eslint-disable no-restricted-properties */
  /** Math.pow restricted for some reason '**'?! */
  return Math.sqrt(numberList.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n)
  /* eslint-enable no-restricted-properties */
}
